export type DatePickerKeyboardAction = 'open' | 'close'

const DATE_PICKER_KEYBOARD_ACTIONS: Record<string, DatePickerKeyboardAction> = {
  'Enter': 'open',
  ' ': 'open',
  'ArrowDown': 'open',
  'Escape': 'close',
}

export function getDatePickerKeyboardAction(key: string): DatePickerKeyboardAction | undefined {
  return DATE_PICKER_KEYBOARD_ACTIONS[key]
}
